module.exports = __webpack_public_path__ + "static/media/temperature.3b542be9.svg";